import React from 'react';
import PropTypes from 'prop-types';
import { Button, Div, Span } from 'components/Ui';
import styles from './styles.scss';

const IndefiniteHold = ({ onOpenEditDelivery }) => (
  <div className={styles.container}>
    <h1>
      <Span translationKey={'IndefiniteHoldText1'}>Hang on! </Span>
      <br />
      <Span translationKey={'IndefiniteHoldText2'}>
        Your account is currently set up for manual ordering.
      </Span>
    </h1>
    <div className={styles.content}>
      <Div translationKey={'IndefiniteHoldText3'}>
        If you would like to place a delivery, please click the order now
        button.
      </Div>
      <Button
        className={styles.btn}
        text="Order Now"
        onClick={onOpenEditDelivery}
      />
      <div>
        <Span translationKey={'IndefiniteHoldText4'}>
          To set up your account for auto deliveries please contact us at{' '}
        </Span>
        <Span translationKey={'PhoneNumber:IndefiniteHold'}>866-407-7873</Span>.
      </div>
    </div>
  </div>
);

IndefiniteHold.propTypes = {
  onOpenEditDelivery: PropTypes.func.isRequired,
};

export default IndefiniteHold;
